import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import isFocusedInboxEnabled from 'mini-mail-focused-inbox-config/lib/isFocusedInboxEnabled';
import selectFocusedPivot from 'mini-mail-list-actions/lib/actions/selectFocusedPivot';
import { INBOX_FOLDER_NAME } from 'mini-mail-common/lib/utils/folderNameConstants';
import { useEffect } from 'react';
import { useMatch, useParams, useSearchParams } from 'mini-react-router-dom';

export const useHandleFocusedOtherNavigation = () => {
    const { folderId } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const viewFilter = searchParams.get('focusedFilter')?.toLowerCase();
    const isInFolderView = !!useMatch({ path: '/:folderId', end: true });

    useEffect(() => {
        if (isInFolderView) {
            if (isFocusedInboxEnabled() && folderId === INBOX_FOLDER_NAME) {
                const selectedFilter = viewFilter === 'other' ? 1 : 0;
                selectFocusedPivot(selectedFilter);
            } else if (searchParams.get('focusedFilter')) {
                searchParams.delete('focusedFilter');
                setSearchParams(searchParams, { replace: true });
            }
        }
    }, [isInFolderView, folderId, viewFilter, searchParams, setSearchParams]);
};
